export default __webpack_public_path__ + "static/media/punto-originario-selected-typ.0e31cfcc.svg";